import React from 'react';
import { Button } from "@mui/material";
import Div from "@jumbo/shared/Div";

const getButtonStyles = (preset, disabled, textSize, btnStyle) => {
  const baseStyles = {
    textTransform: 'unset',
    fontSize: textSize,
  };

  const presetStyles = {
    round: {
      height: '40px',
      backgroundColor: disabled ? '#E0E0E0' : '#C21B17',
      color: disabled ? '#9E9E9E' : '#FFFFFF',
      borderRadius: '20px',
      ...baseStyles,
      '&.MuiButtonBase-root:hover': {
        backgroundColor: disabled ? '#E0E0E0' : '#B31A16',
      },
    },
    primary: {
      height: '56px',
      backgroundColor: disabled ? '#E0E0E0' : '#C21B17',
      color: disabled ? '#9E9E9E' : '#FFFFFF',
      borderRadius: '4px',
      fontWeight: 500,
      ...baseStyles,
      '&.MuiButtonBase-root:hover': {
        backgroundColor: disabled ? '#E0E0E0' : '#AA1B17',
      },
    },
    secondary: {
      height: '56px',
      backgroundColor: '#FFFFFF',
      border: '1px solid #CCCCCC',
      color: disabled ? '#9E9E9E' : '#C21B17',
      borderRadius: '4px',
      fontWeight: 500,
      boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.12)',
      ...baseStyles,
      '&.MuiButtonBase-root:hover': {
        backgroundColor: disabled ? '#FFFFFF' : '#F6F6F6',
        border: disabled ? '1px solid #CCCCCC' : '1px solid #C21B17',
      },
    },
    secondaryRound: {
      height: '40px',
      backgroundColor: '#FFFFFF',
      border: disabled ? '1px solid #CCCCCC' : '1px solid #C21B17',
      color: disabled ? '#9E9E9E' : '#C21B17',
      borderRadius: '20px',
      ...baseStyles,
      '&.MuiButtonBase-root:hover': {
        backgroundColor: disabled ? '#FFFFFF' : '#f3f3f3',
      },
    },
    default: {
      height: '54px',
      backgroundColor: disabled ? '#E0E0E0' : '#C21B17',
      color: disabled ? '#9E9E9E' : '#FFFFFF',
      borderRadius: '10px',
      ...baseStyles,
      '&.MuiButtonBase-root:hover': {
        backgroundColor: disabled ? '#E0E0E0' : '#B31A16',
      },
    },
  };

  return {
    ...(presetStyles[preset] ?? presetStyles.default),
    ...btnStyle,
  };
};

const ButtonStyled = ({
  sx,
  btnText,
  size,
  type,
  onClick,
  preset,
  btnStyle,
  disabled,
  fullWidth = true,
  textSize = "16px",
}) => {
  const buttonStyles = getButtonStyles(preset, disabled, textSize, btnStyle);

  return (
    <Div sx={{ position: 'relative', width: '100%', ...sx }}>
      <Button
        onClick={onClick}
        variant="contained"
        disableElevation
        type={type}
        size="small"
        fullWidth={fullWidth}
        disabled={disabled}
        sx={buttonStyles}
      >
        {btnText}
      </Button>
    </Div>
  );
};

export default ButtonStyled;